import React, { useRef } from 'react';
import { Alert } from 'react-bootstrap';
import ReactQuill from 'react-quill-new';
import type { DeltaStatic, EmitterSource } from 'react-quill-new';
import ReactHtmlParser from 'html-react-parser';

export default (props: {
  value?: string;
  readOnly?: boolean;
  onChange(value?: string): void;
  uniqueKey?: string;
  withoutSize?: boolean;
}) => {
  const quillRef = useRef<ReactQuill>(null);

  const toolbarOptions = props.withoutSize
    ? [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ]
    : [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ];
  const modules = {
    toolbar: toolbarOptions,
  };

  const handleChange = (
    value: string,
    _delta: DeltaStatic,
    source: EmitterSource,
  ) => {
    if (source !== 'user') {
      return;
    }

    const quill = quillRef.current?.getEditor();

    if (!quill) {
      return;
    }

    const text = quill.getText().trim();
    props.onChange(text.length === 0 ? undefined : value);
  };

  return (
    <>
      {props.readOnly ? (
        <div>
          <Alert
            className="alert-disabled ql-editor quill-text-editor"
            style={{
              minHeight: '38px',
              marginBottom: '0',
            }}
          >
            {ReactHtmlParser(props.value || '')}
          </Alert>
        </div>
      ) : (
        <ReactQuill
          ref={quillRef}
          key={props.uniqueKey || 'quill-editor'}
          modules={modules}
          theme="snow"
          value={props.value}
          onChange={handleChange}
          placeholder=""
          preserveWhitespace={false}
          className="quill-text-editor"
        />
      )}
    </>
  );
};
